<template>
    <span class="c-badge-wrapper badge" :class="typeClasses">
        <template v-if="!slots.default">{{ text }}</template>
        <slot />
    </span>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';
import { BadgeVariant, BadgeColorVariant } from '.';

const props = withDefaults(
    defineProps<{
        variant?: BadgeVariant;
        color?: BadgeColorVariant;
        text?: string;
        pill?: boolean;
    }>(),
    { variant: 'light', color: 'default' }
);

const slots = useSlots();

const typeClasses = computed(() => {
    const types: Record<BadgeVariant, Record<string, Record<string, string>>> = {
        ['outline']: {
            // TODO: configurations for outline badges
        },
        ['light']: {
            yellow: {
                bg: 'bg-yellow-lighter',
                color: 'color-yellow-dark'
            },
            blue: {
                bg: 'bg-blue-lighter',
                color: 'color-blue'
            },
            orange: {
                bg: 'bg-orange-lighter',
                color: 'color-orange'
            },
            purple: {
                bg: 'bg-purple-lighter',
                color: 'color-purple'
            },
            cyan: {
                bg: 'bg-cyan-lightest',
                color: 'color-cyan-dark'
            },
            default: {
                bg: 'bg-gray-lightest',
                color: 'color-gray-600'
            }
        },
        ['fill']: {
            // TODO: configurations for fill badges
        }
    };
    const classes = Object.values(types[props.variant]?.[props.color]);

    if (props.pill) {
        classes.push('badge-pill');
    }

    return classes;
});
</script>

<style lang="scss" scoped>
.c-badge-wrapper {
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
    text-transform: initial;
}
</style>
